import { render, staticRenderFns } from "./test-items-edit.vue?vue&type=template&id=18847d23&scoped=true&"
import script from "./test-items-edit.vue?vue&type=script&lang=ts&"
export * from "./test-items-edit.vue?vue&type=script&lang=ts&"
import style0 from "./test-items-edit.vue?vue&type=style&index=0&id=18847d23&prod&lang=scss&scoped=true&"
import style1 from "./test-items-edit.vue?vue&type=style&index=1&id=18847d23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18847d23",
  null
  
)

export default component.exports